// --------------------------------------------------------
// AGENDA DIA - AgendaDia
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import moment, { Moment } from 'moment';
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import AgendaMesHorarioListItem from '../../components/criarAgenda/AgendaMesHorarioListItem';
import { StyledCheckbox, StyledText } from '../../components/criarAgenda/AgendaMesHorarioListItem.styled';
import CriarAgendaHeader from '../../components/criarAgendaHeader/CriarAgendaHeader';
import GenericModal from '../../components/genericModal/GenericModal';
import ListHeader from '../../components/itemList/ListHeaders';
import { GenericSolidButton } from '../../components/UI/buttons/Button.styled';
import ContainerWithSidebar from '../../components/UI/containerWithSidebar/ContainerWithSidebar';
import { H1, TextLink } from '../../components/UI/generalLayout/Layout.styled';
import Colors from '../../constants/Colors';
import { AgendaService } from '../../core/http/service/AgendaService';
import { Paths } from '../../enums/Paths';
import AgendaMesDiaHorario from '../../models/core/agenda/AgendaMesDiaHorario';
import BaseResponse from '../../models/core/BaseResponse';
import { CompanyListContainer } from '../company/CompanyList.styled';
import { GeneralContainer } from '../home/Home.styled';
import { ReactComponent as Block } from '../../assets/imgs/protectionLock.svg'
import { ReactComponent as TrashBin } from '../../assets/imgs/trashBin.svg'
import { useAppDispatch } from '../..';
import * as agendaActions from '../../store/actions/agenda';
import { getDateDescription, handleBackendErrors } from '../../helpers/HelperFunctions';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';

// --------------------------------------------------------
// AGENDA DIA INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function AgendaDia(): JSX.Element {
    // --------------------------------------------------------
    // AGENDA DIA PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { state }: any = useLocation();
    const { nomeProfissional, data, agenda, profissionalInfo } = state;
    const [agendasDiaHeaderFields] = useState([{ name: 'Data', width: '16%', align: null }, { name: 'Horário', width: '15%', align: null }, { name: 'Unidades', width: '50%', align: 'left' }, { name: 'Ações', width: '8%', align: 'left' }])
    const [agendaDia, setAgendaDia] = useState<any[]>([])
    const [showModalInactivateAll, setShowModalInactivateAll] = useState(false)
    const [isAllSelectedCheckbox, setIsAllSelectedCheckbox] = useState(false)
    const [isBlockAllAction, setIsBlockAllAction] = useState(false)
    const [isDeleteAllAction, setIsDeleteAllAction] = useState(false)
    const [selectedAgendasList, setSelectedAgendasList] = useState<any[]>([])
    const [isSelectedButtonsDisabled, setIsSelectedButtonsDisabled] = useState<boolean>(false)
    const [generalErrors, setGeneralErrors] = useState<any[]>([])
    const [activeCount, setActiveCount] = useState<number>(0)
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const  { isMobile } = useResponsiveInfo();

    const fetchAgendaDia = useCallback(async () => {
        const service: AgendaService = new AgendaService();
        const retorno: AgendaMesDiaHorario[] = []
        let activeCount = 0;
        const params = {
            turnoDiaId: data.turnoDiaId
        }
        const response: any = await service.getAgendasProfissionalDiaHorario(params)
        const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data);
        baseResponse.data.forEach((d: any) => {
            if(!d.inativo){
                activeCount++;
            }

            const horarioInicio: Moment = moment.utc(d.horario)
            const horarioFim: Moment = moment.utc(d.horario)
            horarioFim.add(d.duracaoMinutos, 'm')

            const obj: AgendaMesDiaHorario = new AgendaMesDiaHorario().fromJSON(
                {
                    ...d,
                    turnoDiaId: data.turnoDiaId,
                    data: moment.utc(d.horario).format('DD/MM/YYYY'),
                    horaInicio: horarioInicio.format('HH:mm'),
                    horaFim: horarioFim.format('HH:mm'),
                    unit: agenda.unidade[0]
                }
            )
            retorno.push(obj)
        })

        setAgendaDia(retorno)
        setActiveCount(activeCount)
    }, [data])

    useEffect(() => {
        fetchAgendaDia();
    }, [])

    useEffect(() => {
        if(selectedAgendasList.length === 0){
            setIsSelectedButtonsDisabled(true)
        }else{
            setIsSelectedButtonsDisabled(false)
        }
    }, [selectedAgendasList])

    const addAllToList = () => {
        if (selectedAgendasList.length === agendaDia.length || selectedAgendasList.length === activeCount) {
            setIsAllSelectedCheckbox(false)
            setSelectedAgendasList([])
        } else {
            setIsAllSelectedCheckbox(true)
            agendaDia.forEach((agenda: any,) => {
                setSelectedAgendasList((prev: any) => {
                    const list = [...prev]
                    const index = list.findIndex((element: any) => {
                        return element.id === agenda.id
                    })

                    index === -1 && !agenda.inativo && agenda.ativavel && list.push(agenda)
                    return list;
                })
            })
        }
    }

    const addAgendaToList = (data: any, id: string) => {
        setIsAllSelectedCheckbox(false)
        setSelectedAgendasList((prev: any) => {
            const list = [...prev]
            const index = list.findIndex((element: any) => {
                return element.id === id
            })

            index === -1 ? list.push(data) : list.splice(index, 1)
            return list;
        })
    }

    const isAgendaOnList = (id: any) => {
        const agendaOnList = selectedAgendasList.filter(p => {
            return p.id === id;
        })
        return agendaOnList.length > 0;
    }

    const onBlockSelectedClick = () => {
        if (selectedAgendasList.length > 0) {
            setIsBlockAllAction(true);
            setIsDeleteAllAction(false);
            setShowModalInactivateAll(true)
        }
    }

    const blockSelected = async ()=>{
        selectedAgendasList.forEach(async a=>{
            try{
                await dispatch(agendaActions.activateOrDeactivateAgendaTurnoDiaHorario(a.agendaId, a.turnoDiaId, a.id, a.inativo))
                fetchAgendaDia()
            }catch(error: any){
                handleBackendErrors(error, setGeneralErrors)
            }
        })
        setShowModalInactivateAll(false)
        setIsAllSelectedCheckbox(false)
        setSelectedAgendasList([])
    }

    const onDeleteSelectedClick = () => {
        if (selectedAgendasList.length > 0) {
            setIsBlockAllAction(false);
            setIsDeleteAllAction(true);
            setShowModalInactivateAll(true)
        }
    }

    const deleteSelected = async ()=>{
        selectedAgendasList.forEach(async a=>{
            try{
                await dispatch(agendaActions.deleteAgendaTurnoDiaHorario(a.agendaId, a.turnoDiaId, a.id))
                fetchAgendaDia()
            }catch(error: any){
                handleBackendErrors(error, setGeneralErrors)
            }
        })
        setShowModalInactivateAll(false)
        setIsAllSelectedCheckbox(false)
        setSelectedAgendasList([])
    }

    const onBack = () => {
        const mes = { mes: agenda.mes, mesDescricao: agenda.mesDescricao, ano: String(moment(agenda.dataFim).year()) }
        return navigate(Paths.AgendasMes, { state: { nomeProfissional: nomeProfissional, mesFormatado: `${mes.mesDescricao} de ${mes.ano}`, agenda: agenda, profissionalInfo: profissionalInfo } })
    }

    const activateInactivateAgendaMesHorarioDia = async (agendaId: string, turnoDiaId: string, turnoDiaHorarioId: string, isActivate: boolean) => {
        try{
            await dispatch(agendaActions.activateOrDeactivateAgendaTurnoDiaHorario(agendaId, turnoDiaId, turnoDiaHorarioId, isActivate))
            fetchAgendaDia()
        }catch(error: any){
            handleBackendErrors(error, setGeneralErrors)
        }
    }

    const deleteAgendaTurnoDiaHorario = async (agendaId: string, turnoDiaId: string, turnoDiaHorarioId: string) => {
        try{
            await dispatch(agendaActions.deleteAgendaTurnoDiaHorario(agendaId, turnoDiaId, turnoDiaHorarioId))
            fetchAgendaDia()
        }catch(error: any){
            handleBackendErrors(error, setGeneralErrors)
        }
    }

    const mountModalMsg = () => {
        return 'Tem certeza que deseja ' + (isBlockAllAction ? 'bloquear' : 'excluir') + ' todas as agendas selecionadas?'
    }

    return <ContainerWithSidebar>
        <GeneralContainer>
            <TextLink color={Colors.SPM600} onClick={onBack}>{'< Voltar para a agenda do mês'}</TextLink>
            <CriarAgendaHeader nome={nomeProfissional} agenda={profissionalInfo} errors={generalErrors} onCloseError={()=>{ setGeneralErrors([]) }}/>
            <div style={{ flexDirection: isMobile? 'column':'row', display: 'flex', paddingLeft: isMobile? 10 : 0, paddingRight: isMobile? 10:0, justifyContent: 'space-between' }}>
                <H1>{getDateDescription(data.data)}</H1>
                <div style={{ flexDirection: 'row', display: 'flex', justifyContent:'space-between' }}>
                    {isMobile && (<GenericSolidButton color={Colors.SPM600} disabled={isSelectedButtonsDisabled} style={{ marginRight: 5 }} onClick={onBlockSelectedClick}>Bloquear selecionados</GenericSolidButton>)}
                    {isMobile && (<GenericSolidButton color={Colors.error} disabled={isSelectedButtonsDisabled} onClick={onDeleteSelectedClick}>Excluir selecionados</GenericSolidButton>)}

                    {!isMobile && (<>
                        <div>
                            <GenericSolidButton color={Colors.SPM600} disabled={isSelectedButtonsDisabled} onClick={onBlockSelectedClick}>Bloquear selecionados</GenericSolidButton>
                        </div>
                        <div style={{ marginLeft: 10 }}>
                            <GenericSolidButton color={Colors.error} disabled={isSelectedButtonsDisabled} onClick={onDeleteSelectedClick}>Excluir selecionados</GenericSolidButton>
                        </div>
                    </>)}
                </div>
            </div>
            <div style={{ flexDirection: 'row', display: 'flex', width: '100%' }}>
                <StyledCheckbox checked={isAllSelectedCheckbox} onChange={addAllToList} />
                <div style={{ width: '100%' }}>
                    {isMobile? (<StyledText>Selecione todos</StyledText>):(<ListHeader fields={agendasDiaHeaderFields} />)}
                </div>
            </div>
            <CompanyListContainer>
                {agendaDia.map((agendaDia: any) => {
                    return <AgendaMesHorarioListItem
                        profissionalInfo={profissionalInfo}
                        agenda={agenda}
                        data={agendaDia}
                        nome={nomeProfissional}
                        isAgendaDiaria
                        activateInactivateAgendaMesHorario={() => { } }
                        isOnSelectedList={isAgendaOnList(agendaDia.id)}
                        addObjectToSelectedList={() => { addAgendaToList(agendaDia, agendaDia.id); } }
                        activateInactivateAgendaMesDiaHorario={activateInactivateAgendaMesHorarioDia} 
                        deleteAgendaTurnoDia={()=>{}}
                        deleteAgendaTurnoDiaHorario={deleteAgendaTurnoDiaHorario}
                    />
                })}
            </CompanyListContainer>

            <GenericModal
                visible={showModalInactivateAll}
                Icon={() => { return isBlockAllAction ? <Block width="120" height="120" /> : <TrashBin width="120" height="120" /> }}
                onCancel={isBlockAllAction? async ()=>{ await blockSelected(); } : async () => { await deleteSelected() }}
                onConfirm={() => { setShowModalInactivateAll(false) }}
                modalTitle={mountModalMsg()}
                modalSubtitle={''}
                cancelButtonMsg={'Voltar'}
                confirmButtonMsg={isBlockAllAction ? 'Bloquear' : 'Excluir'}
            />
            
        </GeneralContainer>
    </ContainerWithSidebar>;
}

export default AgendaDia;
